import React, {Component} from 'react';
// import {Link} from 'react-router-dom';
import {HashLink as Link} from 'react-router-hash-link';
import PresidenteCasilla from './../../../img/presidenteCasilla.png';
import SecretarioCasilla from './../../../img/secretarioCasilla.png';
import Escrutadores from './../../../img/escrutadores.png';
import SuplentesGral from './../../../img/suplentesGral.png';
import AccionesComunes from '../../AccionesComunes';

class FuncionariosCasilla extends Component {

    componentDidMount(){
        document.title = "Ayuda | Funcionarios de casilla"

        var activeMenu = document.getElementById("FuncCasilla");
        activeMenu.classList.add("active");
    }

    componentWillUnmount(){
        document.getElementById("conoceSIJE").classList.remove("active");
        document.getElementById("FuncCasilla").classList.remove("active");
        document.getElementById("jornadaElec").classList.remove("active");
        document.getElementById("preguntasFrec").classList.remove("active");

        var colapsarMenu = document.getElementById("menuResponsivo");
        colapsarMenu.classList.replace("show", "not");
    }

    render () {
        return (
            <div className="container contenido">
                <AccionesComunes />
                <div className="migajas">
                    <small>
                        <Link to="./QueEsSIJE">Inicio</Link>
                        <span>Acerca de las casillas</span>
                        <span>Funcionarios de casilla</span>
                    </small>
                </div>
                <div className="col-md-12 text-center">
                    <h1 className="tituloPagina">Funcionarios de casilla</h1>
                    <p className="centrar">
                        Para el Proceso Electoral 2021 las mesas directivas de casilla se componen de un Presidente(a), dos Secretario(a)s y tres Escrutadores.
                    </p>
                </div>

                <div className="row bordes">
                    <div className="col-md-12 text-center">
                        <h2>Presidente(a)</h2>
                    </div>
                    <div className="col-md-6 centrar-vertical horizontal">
                        <img src={PresidenteCasilla} alt="Presidente de casilla" />
                    </div>
                    <div className="col-md-6">
                        <p>
                            Es el encargado de resguardar el paquete electoral hasta el día de la elección, y devolverlo al Consejo Distrital una vez concluida la votación.
                        </p>
                    </div>
                </div>

                <div className="row bordes">
                    <div className="col-md-12 text-center">
                        <h2>Secretario(a)</h2>
                    </div>
                    <div className="col-md-6">
                        <p>
                            Su función es registrar toda la información de la casilla en el Acta de la Jornada Electoral, como son:
                        </p>
                        <ul>
                            <li>El número de boletas electorales.</li>
                            <li>Nombre de todos los funcionarios de casilla.</li>
                            <li>Incidentes presentados en la casilla.</li>
                            <li>Nombre de los Representantes PPN / PPL/ CIF/ CIL.</li>
                        </ul>
                    </div>
                    <div className="col-md-6 centrar-vertical horizontal">
                        <img src={SecretarioCasilla} alt="Secretario de casilla" />
                    </div>
                </div>

                <div className="row bordes">
                    <div className="col-md-12 text-center">
                        <h2>Escrutadores</h2>
                    </div>
                    <div className="col-md-6 centrar-vertical horizontal">
                        <img src={Escrutadores} alt="Escrutadores de casilla" />
                    </div>
                    <div className="col-md-6">
                        <p>
                            Auxilian al Presidente(a) en las labores de instalación de casilla, marcar el dedo de los electores que hayan votado, y con la integración del paquete electoral.
                        </p>
                    </div>
                </div>

                <div className="row bordes">
                    <div className="col-md-12 text-center">
                        <h2>Suplentes generales</h2>
                    </div>
                    <div className="col-md-6">
                        <p>
                            Tienen la obligación de presentarse en la casilla antes de la instalación, y en caso necesario ocupan un cargo en la <Link to="./Glosario#m">mesa directiva de casilla</Link>.
                        </p>
                    </div>
                    <div className="col-md-6 centrar-vertical horizontal">
                        <img src={SuplentesGral} alt="Suplentes generales" />
                    </div>
                </div>
            </div>
        )
    }
}

export default FuncionariosCasilla;